<template>
  <div>
    <div class="pa-3 grey lighten-4">
      <v-flex xs12 style="text-align: right;">
        <v-btn color="primary" @click="GetData">
          Save
        </v-btn>
      </v-flex>
    </div>
    <v-card elevation="2" tile class="mb-4">
      <v-card-title>
        <v-layout row wrap>
          <v-flex xs6>
            <v-tabs
                background-color="transparent"
                color="basil"
                grow
                v-model="widget_language"
            >
              <v-tab
                v-for="language in enabledLanguages" :key="language.value"
              >
                  {{ language.text }}
              </v-tab>
            </v-tabs>
          </v-flex>
          <v-flex xs6>
            <div style="float: right;" v-if="widget_language === 0">
              <v-tooltip 
                bottom
                max-width="300"
                color="grey darken-3"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    color="grey lighten-3"
                    class="override-btn"
                    outlined
                    style="float:right"
                    small
                    @click="replicateAll"
                  >
                  {{ $t('language_copy_all_button_label') }}
                  </v-btn>
                </template>
                <div class="pa-2">
                  <div class="body-2">{{ $t('language_copy_all_button_info') }}</div>
                </div>
              </v-tooltip>
            </div>
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-card-text class="mt-3">
        <v-tabs-items v-model="widget_language">
          <v-tab-item v-for="(language, index) in enabledLanguages" :key="language.name">
            <div :id="'grape-editor-' + index" style="height: 900px;"></div>
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import i18n from "@/i18n";
import grapesjs from 'grapesjs/dist/grapes.min.js';
import 'grapesjs/dist/css/grapes.min.css';
import grapesjsPresetWebpage from 'grapesjs-preset-webpage';
import DEFINES from "@/defines";
import { mapState  } from "vuex";
export default {
  name: 'FestivalHomePage',
  computed :{
    enabledLanguages() {
        if (this.company) {
            return ('enabled_language_support' in this.company.custom_properties) ? this.company.custom_properties.enabled_language_support : this.i18n_locale; 
        }else{
            return this.i18n_locale
        }
    },
    ...mapState({
      company: (state) => state.company.company,
    }),
  },
  data() {
    return {
      widget_language: 0,
      editor: {},
      editors: {},
      savedData: null
    }
  },
  mounted() {
    this.initEditors()
  },
  beforeDestroy() {
    if (this.editors && this.editors.length) {
      this.editors.forEach((editor, index) => {
        if (editor && typeof editor.destroy === 'function') {
          editor.destroy();
          this.editors[index] = null;
        }
      });
    }

    this.enabledLanguages.forEach((language, index) => {
      const containerId = 'grape-editor-' + index;
      const el = document.getElementById(containerId);
      if (el) el.innerHTML = '';
    });
  },
  methods: {
    initEditors() {
      this.enabledLanguages.forEach((language, index) => {
        const containerId = 'grape-editor-' + index;

        const editor = grapesjs.init({
          container: '#'+containerId,
          height: '900px',
          width: '100%',
          plugins: [grapesjsPresetWebpage],
          panels: {
            defaults: [
              {
                id: 'options',
                buttons: [
                  {
                    id: 'show-layers',
                    active: false,
                    label: '<i class="fa fa-bars"></i>',
                    command: 'show-layers',
                    togglable: false
                  },
                  {
                    id: 'show-style',
                    active: true,
                    label: '<i class="fa fa-paint-brush"></i>',
                    command: 'show-styles',
                    togglable: false
                  },
                  {
                    id: 'show-traits',
                    active: false,
                    label: '💎', // this shows as 💎 settings
                    command: 'show-traits',
                    togglable: false
                  }
                ]
              },
              {
                id: 'views',
                buttons: [
                  {
                    id: 'open-sm',
                    command: 'open-sm',
                    className: 'fa fa-paint-brush',
                    active: true
                  },
                  {
                    id: 'open-layers',
                    command: 'open-layers',
                    className: 'fa fa-bars'
                  },
                  {
                    id: 'open-blocks',
                    command: 'open-blocks',
                    className: 'fa fa-th-large'
                  }
                ]
              }
            ]
          },
          pluginsOpts: {
            [grapesjsPresetWebpage]: {
              blocksBasic: true,
              blocksBasicOpts: {
                blocks: ['column1', 'column2', 'column3', 'column3-7', 'text', 'link', 'image', 'video'],
                flexGrid: 1
              },
              blocks: ['link-block', 'quote', 'text-basic']
            }
          },
          storageManager: {
            id: containerId,
            type: 'local',
            autosave: true,
            storeComponents: true,
            storeStyles: true,
            storeHtml: true,
            storeCss: true,
            stepsBeforeSave: 1,
          },
          deviceManager: {
            devices: [
              {
                id: 'desktop',
                name: 'Desktop',
                width: '',
              },
              {
                id: 'tablet',
                name: 'Tablet',
                width: '768px',
                widthMedia: '992px',
              },
              {
                id: 'mobilePortrait',
                name: 'Mobile portrait',
                width: '320px',
                widthMedia: '575px',
              },
            ]
          },
          css: `
            .image-section {
              width: 100%;
              height: auto;
              max-width: 100%;
              display: block;
              object-fit: contain;
            }
            .image {
              width: 100%;
              max-width: 1200px;
              margin: 0 auto;
              padding: 20px;
              box-sizing: border-box;
            }
          `
        });

        // Store each editor instance
        this.editors[index] = editor;

        // Load initial content
        editor.on('load', () => {
          editor.setComponents(this.getHomePageHtml(language.value));
          editor.setStyle(this.getHomePageCss(language.value));
        });
        
        editor.BlockManager.add('hero-block', {
          label: 'Hero',
          category: 'Sections',
          content:{
            type: 'hero-section', // use a custom component type
            components: `
                <div class="hero-section" style="padding:100px 50px 15px;text-align:center;color:white;">
                  <img data-gjs-type="hero-image" />
                  <h1 style="font-size: 3rem;">Domani Linea d'Ombra Festival 2021</h1>
                </div>
              `
          }
        })

        editor.BlockManager.add('image-block', {
          label: 'Image',
          category: 'Sections',
          content: `
            <section class="image-section">
              <img data-gjs-type="hero-image" />
            </section>
          `
        })

        editor.DomComponents.addType('hero-image', {
          extend: 'image',
          model: {
            defaults: {
              traits: [
                {
                  type: 'text',
                  label: 'Image URL',
                  name: 'src',
                  changeProp: 1
                },
                {
                  type: 'text',
                  label: 'Alt Text',
                  name: 'alt',
                }
              ],
              attributes: {
                src: 'https://yourcdn.com/default.jpg',
                id: 'hero-image-' + Math.floor(Math.random() * 999999), // 🔥 Auto unique ID
              }
            }
          }
        });

        editor.DomComponents.addType('hero-section', {
          model: {
            defaults: {
              tagName: 'section',
              classes: ['hero-section'],
              stylable: ['background-color', 'padding', 'text-align', 'color'], // make bg editable
              attributes: { class: 'hero-section' },
              styles: {
                backgroundColor: '#a42e2d',
                padding: '100px 50px 15px',
                textAlign: 'center',
                color: 'white',
              }
            }
          }
        });

      })
      
    },
    async GetData() {
      const allHtmlCss = {};
      this.enabledLanguages.map((lang, index) => {
        const editor = this.editors[index];

        allHtmlCss[lang.value] = {
          html: editor.getHtml(),
          css: editor.getCss()
        };
      });

      await this.$store.dispatch(
        "company/updateFestivalHomePage",
        {
          id: this.company.id,
          festival_home_page: allHtmlCss,
        }
      )
      .then((response) => {
        console.log(response);
        
        this.$store.dispatch("app/showMessage", {
          message: i18n.t("message.success.updated"),
          color: "success",
        });
      })
      .catch((error) => {
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: "error",
        });
      });
    },
    getHomePageHtml(languageValue) {
      let html = ''
      if (this.company.festival_home_page && this.company.festival_home_page[languageValue]) {
        html = this.company.festival_home_page[languageValue].html || ''
      } else {
        html = DEFINES.VOD_HOMEPAGE_DEFAULT_HTML[languageValue]
      }

      return html
    },
    getHomePageCss(languageValue) {
      let css = ''
      if (this.company.festival_home_page && this.company.festival_home_page[languageValue]) {
        css = this.company.festival_home_page[languageValue].css || ''
      } else {
        css = DEFINES.VOD_HOMEPAGE_DEFAULT_HTML_CSS[languageValue]
      }

      return css
    },
    replicateAll() {
      const defaultLanguage = 'en';
      const defaultHtml = this.getHomePageHtml(defaultLanguage);
      const defaultCss = this.getHomePageCss(defaultLanguage);

      this.enabledLanguages.forEach((language, index) => {
        if (index !== 0) {
          const editor = this.editors[index];
          editor.setComponents(defaultHtml);
          editor.setStyle(defaultCss);
        }
      });
    }
  }     
}
</script>

<style>
.gjs-sm-sector-label {
  color: white !important;
}

/* Add additional GrapesJS styling fixes */
.gjs-am-preview-cont img {
  max-width: 100%;
  max-height: 100px;
  object-fit: contain;
}

.gjs-am-asset {
  cursor: pointer;
  transition: transform 0.2s;
}

.gjs-am-asset:hover {
  transform: scale(1.05);
}

.gjs-am-assets-cont {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
  gap: 10px;
}
.scoped-dynamic-content .image-section {
  width: 100%;
  height: auto;
  max-width: 100%;
  display: block;
  object-fit: contain;
}
.scoped-dynamic-content .image {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  box-sizing: border-box;
}
</style>